/*
 * @Author: 玄离 “hongyuanzhong@cai-inc.com“
 * @Date: 2024-06-07 16:42:29
 * @LastEditors: 玄离 “hongyuanzhong@cai-inc.com“
 * @LastEditTime: 2024-06-11 11:41:42
 * @FilePath: /zcy-claim-front/src/utils/updateJudge.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const { Modal, Alert, Button } = require('@zcy/doraemon');

const mountNode = document.createElement('div');
mountNode.style.position = 'fixed';
mountNode.style.top = '0';
mountNode.style.width = '100%';
mountNode.style.zIndex = '999';
document.body.appendChild(mountNode);
const ReactDOM = require('react-dom');

// ReactDOM.render(
//   <Alert
//     message={<p style={{ margin: 0, textAlign: 'center' }}>
//       <span style={{ fontWeight: 'bolder' }}>系统更新: </span>
//       <span>为保证系统正常使用，请及时保存正在处理的单据。刷新页面使用新版本</span>
//       <Button type="text" onClick={() => window.location.reload()}>刷新</Button>
//     </p>}
//     type="firstinfo" />
//   , mountNode);

let versionMonitorGap = 1000 * 60 * 10; // 10分钟查询一次
let currentVersion = '';
const timmer = time => {
  // 先清理一遍，防止内存溢出
  clearInterval(window.versionMonitor);
  window.versionMonitor = setInterval(() => {
    judge();
  }, time || versionMonitorGap);
};
// JSONP跨域方案
function jsonpRequest(url, callback, success) {
  // 判断这个script是不是已经存在
  let script = document.createElement('script');
  script.id = 'jsonp-script';
  script.src = `${url}?callback=versionCallback&v=${Date.now()}`;
  script.type = 'text/javascript';
  script.async = true;
  window[callback] = function (data) {
    document.body.removeChild(script);
    delete window[callback];

    if (success) {
      success(data);
    }
  };
  document.body.appendChild(script);
}

async function getVersion() {
  let basePath = process.env.ASSET_PREFIX;
  return new Promise((resolve, reject) => {
    // JSONP方式 请求versionData.json, 使用构建时间作为标识，就不需要每次都去改版本号了
    try {
      jsonpRequest(`${basePath}/version.js`, 'versionCallback', data => {
        resolve(data.version);
      });
    } catch (error) {
      console.log('jsonpRequest: ', error);
      reject(error);
    }
  });
}

async function judge() {
  try {
    // 用于记录时间戳的变量，时间戳是响应头中的etag和last-modified字段其中之一
    const lastUpdateVersion = localStorage.getItem('last-update-version');
    // 获取当前最新的时间戳
    currentVersion = await getVersion();
    // 检测到最新请求的时间戳和上一次不一致，即文件发生变化
    if (lastUpdateVersion !== currentVersion) {
      // 弹窗出现时，清理计时器
      clearInterval(window.versionMonitor);
      // 动态添加提示信息到页面顶部

      // 这里编写更新逻辑
      // Modal.info({
      //   title: '系统更新',
      //   content: (
      //     <div>
      //       <p>为保证系统正常使用，请及时保存正在处理的单据。刷新页面使用新版本</p>
      //     </div>
      //   ),
      //   cancelText: '稍后处理',
      //   okText: '刷新',
      //   okCancel: true,
      //   onOk() {
      //     window.location.reload();
      //   },
      //   onCancel() {
      //     // 取消之后，半小时提醒
      //     timmer(versionMonitorGap * 30);
      //   },
      // });
      ReactDOM.render(
        <Alert
          message={
            <p style={{ margin: 0, textAlign: 'center' }}>
              <span style={{ fontWeight: 'bolder' }}>系统更新: </span>
              <span>为保证系统正常使用，请及时保存正在处理的单据。刷新页面使用新版本</span>
              <Button type="text" onClick={() => window.location.reload()}>
                刷新
              </Button>
            </p>
          }
          type="firstinfo"
        />,
        mountNode,
      );
    }
  } catch (error) {
    // 处理错误
    clearInterval(window.versionMonitor);
  }
}

// 仅在生产环境开启版本监控
// process.env.NODE_ENV !== 'development' &&
(async function () {
  // 清理定时器
  window.versionMonitor && clearInterval(window.versionMonitor);
  // 默认获取一次版本，避免刷新加载进来的用户出现弹窗
  getVersion().then(e => {
    localStorage.setItem('last-update-version', e);
    // 开启轮询执行judge函数 1分钟执行一次，避免资源浪费
    timmer();
  });
})();
